<div [style.max-width]="pedido ? '1900px' : '1700px'" [style.margin-left]="'auto'"
  [style.margin-right]="pedido ? '0' : 'auto'" class="container row mb-5">
  <div class="min-width {{
      pedido && mostraCarrinhoCatalogo ? 'col-md-10' : 'col-md-12'
    }}">
    <span class="bread-crumb">
      <p class="bread-crumb" *ngIf="
          breadCrumb !== '' || breadCrumb.length > 0 || breadCrumb[0] !== ''
        ">
        <a (click)="mainCatalog()" *ngIf="breadCrumb.length > 0 || lastElement !== ''"
          style="color: #777; cursor: pointer">
          Home >
        </a>
        <a *ngFor="let b of breadCrumb; let i = index">
          <span class="link-bc" (click)="showMenu(b, this.breadCrumb)">
            {{ b.replaceAll("_", " ") + " > " }}
          </span>
        </a>
        <span class="last-element">{{ lastElement || "" }}</span>
      </p>
    </span>
    <div class="row" style="border-bottom: 1px solid #e5e5e5; padding-bottom: 0.5rem">
      <div class="col-xl-2 col-lg-3 col-md-3 col-sm-5 col-6 p-0"
        style="padding-left: 30px !important; padding-top: 10px !important">
        <div class="info1" *ngIf="totalElements > 0" i18n>
          {{ totalElements }} produtos encontrados
        </div>
        <div (mouseenter)="this.dropdown = true" (mouseleave)="this.dropdown = false" (click)="this.dropdown = false">
          <!-- <button
        class="clear-button"
        (click)="limpaBuscaFiltros()"
        >
        Limpar Filtros
      </button> -->
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-3 col-sm-1 col-4">
        <div class="d-flex row" style="display: flex; flex-wrap: wrap" *ngIf="!productService.loadingCatalogo">
          <div *ngFor="let filter of productService.filtroDescr" style="margin-right: 0.5rem; margin-top: 0.3rem">
            <span class="badge badge-primary">
              <span class="descr1" style="margin-right: 0.3rem">{{
                filter.label
                }}</span>
              <span class="badge badge-light descr1" (click)="limpaBuscaDescr(filter.id, filter.filtro)">X</span>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-lg-5 col-md-6 col-sm-6 pr-1">
        <div class="row pl-2 pr-2" *ngIf="totalElements > 0" style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          ">
          <table>
            <tr *ngIf="mobile">
              <td>
                <a href="javascript:void(0);" *ngIf="exibe1x1" (click)="onMostraGrade2()">|<img src="assets/1x1.png"
                    width="20" /><i *ngIf="productService.visualizacaoModo == 'grade2'"
                    style="font-size: 18px; color: green" class="icofont-check">
                  </i></a>
                <a href="javascript:void(0);" *ngIf="exibe4x4" (click)="onMostra4em4()">|<img src="assets/janela.png"
                    width="20" /><i *ngIf="productService.visualizacaoModo == '4x4'"
                    style="font-size: 18px; color: green" class="icofont-check">
                  </i>
                </a>
                <a href="javascript:void(0);" *ngIf="exibe6x6" (click)="onMostra6em6()">|<img src="assets/6x6.png"
                    width="18" style="margin-left: 7px" /><i *ngIf="productService.visualizacaoModo == '6x6'"
                    style="font-size: 18px; color: green" class="icofont-check"></i></a>
                <a href="javascript:void(0);" *ngIf="exibeGrade" (click)="onMostraGrade()">|<img src="assets/sku.png"
                    width="20" style="margin-left: 7px" />
                  <i *ngIf="productService.visualizacaoModo == 'grade'" style="font-size: 18px; color: green"
                    class="icofont-check"></i></a>
                <a href="javascript:void(0);" *ngIf="exibeGradeCliente" (click)="onMostraGradeClientes()">|<img
                    src="assets/lista.png" width="20" style="margin-left: 7px" /><i
                    *ngIf="productService.visualizacaoModo == 'gradeClientes'" style="font-size: 18px; color: green"
                    class="icofont-check"></i></a>
              </td>
            </tr>
            <tr>
              <td *ngIf="!mobile">
                <a href="javascript:void(0);" *ngIf="exibe1x1" (click)="onMostraGrade2()"><img src="assets/1x1.png"
                    width="20" /><i *ngIf="productService.visualizacaoModo == 'grade2'"
                    style="font-size: 18px; color: green" class="icofont-check"></i></a>
                <a href="javascript:void(0);" *ngIf="exibe4x4" (click)="onMostra4em4()">|<img src="assets/janela.png"
                    width="20" /><i *ngIf="productService.visualizacaoModo == '4x4'"
                    style="font-size: 18px; color: green" class="icofont-check">
                  </i>
                </a>
                <a href="javascript:void(0);" *ngIf="exibe6x6" (click)="onMostra6em6()">|<img src="assets/6x6.png"
                    width="18" style="margin-left: 7px" /><i *ngIf="productService.visualizacaoModo == '6x6'"
                    style="font-size: 18px; color: green" class="icofont-check"></i></a>
                <a href="javascript:void(0);" *ngIf="exibeGrade" (click)="onMostraGrade()">|<img src="assets/sku.png"
                    width="20" style="margin-left: 7px" /><i *ngIf="productService.visualizacaoModo == 'grade'"
                    style="font-size: 18px; color: green" class="icofont-check"></i></a>
                <a href="javascript:void(0);" *ngIf="exibeGradeCliente" (click)="onMostraGradeClientes()">|<img
                    src="assets/lista.png" width="20" style="margin-left: 7px" /><i
                    *ngIf="productService.visualizacaoModo == 'gradeClientes'" style="font-size: 18px; color: green"
                    class="icofont-check"></i></a>
              </td>
              <td class="align-middle">
                <span class="info1" i18n>Ordenar&nbsp;por:&nbsp;</span>
              </td>
              <td>
                <div class="form-group mb-0">
                  <select (change)="onSortChange($event)" [(ngModel)]="productService.selectedOrder"
                    class="form-control form-control-sm">
                    <option value="1" i18n>Recentes</option>
                    <option value="2">A - Z</option>
                    <option value="3">Z - A</option>
                    <option value="4" i18n>Maior preço</option>
                    <option value="5" i18n>Menor preço</option>
                  </select>
                </div>
              </td>
              <td>
                <div class="dropleft">
                  <div aria-labelledby="dropdownMenuLink">
                    <a href="javascript:void(0);" (click)="share()"><img src="assets/compartilhar.png" width="20"
                        style="margin-top: -14px" /></a>
                    <a href="javascript:void(0);" (click)="geraPdfCatalogo()" class="print-btn" [style.marginTop]="'4px'"
                      *ngIf="!loadPdf">
                      <mat-icon> picture_as_pdf </mat-icon>
                    </a>
                    <div *ngIf="loadPdf" class="lds-dual-ring"></div>
                    <!-- <a href="javascript:void(0);" (click)="onSomenteComFotos()"
                    ><img src="assets/fotos.png" width="20" /><span
                      *ngIf="productService.mostraComFotoModo"
                      class="verde"
                      >on</span
                    ><span
                      *ngIf="!productService.mostraComFotoModo"
                      class="vermelho"
                      >off</span
                    ></a
                  >
                  <a
                    *ngIf="SITE.mostraDisponivelCatalogo"
                    href="javascript:void(0);"
                    (click)="onSomenteDisponiveis()"
                    ><img src="assets/fotos.png" width="20" />
                    <span
                      *ngIf="productService.somenteDisponiveis"
                      class="verde"
                      >on</span
                    ><span
                      *ngIf="!productService.somenteDisponiveis"
                      class="vermelho"
                      >off</span
                    ></a
                  > -->
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div *ngIf="filtros" #filterRef class="filter-panel col-md-2" [class.show]="filterVisible" [class.mobile]="mobile"
        [class.desktop]="!mobile">
        <app-catalog-filter [filters]="filtros" [filtros]="filters" [catalogItems]="itensCatalogo"
          (onFilter)="filtrar($event)" (onPriceFilter)="send($event)" (onClearSearch)="limpaBusca($event)"
          (onItemClear)="removeItem($event)" (onTotalClear)="limpaTudo()" (onFilterClear)="limpaBuscaFiltros()"
          (onClearSearchDescription)="limpaBuscaDescr($event.id, $event.filter)"
          (filtrarPorMenuDinamico)="filtrarPorMenuDinamico($event)" (removeItemBusca)="filtrarPorMenuDinamico($event)"
          (breadCrumbEm)="breadCrumbSave($event)"></app-catalog-filter>
      </div>
      <div class="col-md-10 pr-1 min-width min-width">
        <div id="print" class="pl-2 pr-2 pb-5" style="background-color: white">
          <div *ngIf="!productService.loading && totalElements === 0" class="row pt-4">
            <div class="col-lg-6 offset-lg-3 text-center">
              <img src="assets/empty.png" class="img-fluid" />
              <h4 i18n>Nenhum produto encontrado!</h4>
            </div>
          </div>
          <div *ngIf="!productService.visualizacaoModo.startsWith('grade')"
            style="min-height: 500px; margin-top: 0 !important" class="row mt-2 gcc-produtos pl-2" id="print">
            <div *ngFor="let p of products" class="col-xl-{{ produtoColXL }} col-lg-4 col-6 p-2 produto"
              [class.indisponivel]="!p.estoque && SITE.mostraDisponivelCatalogo"
              [style.marginBottom]="'10px !important'">
              <!-- {{p| json}} -->
              <app-catalog-item [product]="p" [produtoColXL]="produtoColXL" [produtoHeight]="produtoHeight"
                [produtoDescrHeight]="produtoDescrHeight" [produtoDescrFontSize]="produtoDescrFontSize"
                [produtoIndispFontSize]="produtoIndispFontSize" [produtoDescrLen]="produtoDescrLen"
                (redirectTo)="redirectTo(p.id)"></app-catalog-item>
            </div>
          </div>
          <div style="display: none">
            <div *ngIf="!productService.visualizacaoModo.startsWith('grade')" style="min-height: 500px"
              class="row mt-2 gcc-produtos pl-2">
              <div *ngFor="let p of products" class="col-xl-{{ produtoColXL }} col-lg-4 col-6 p-2 produto"
                [class.indisponivel]="
                  !p.estoque && SITE.mostraDisponivelCatalogo
                " [style.marginBottom]="'10px !important'">
                <!-- {{p| json}} -->
                <app-catalog-item [product]="p" [produtoColXL]="produtoColXL" [produtoHeight]="produtoHeight"
                  [produtoDescrHeight]="produtoDescrHeight" [produtoDescrFontSize]="produtoDescrFontSize"
                  [produtoIndispFontSize]="produtoIndispFontSize" [produtoDescrLen]="produtoDescrLen"
                  (redirectTo)="redirectTo(p.id)"></app-catalog-item>
              </div>
            </div>
          </div>

          <div *ngIf="productService.visualizacaoModo == 'grade'" style="min-height: 300px; overflow-x: auto"
            class="row mt-2 gcc-produtos">
            <form [formGroup]="form" style="width: 100%">
              <div *ngIf="products.length > 0" class="table-responsive">
                <table class="table table-hover table-condensed table-sm" [style.font-size.rem]="produtoDescrFontSize">
                  <thead class="table-head">
                    <tr>
                      <th></th>
                      <th i18n>Produto</th>
                      <th i18n>Cor</th>
                      <th i18n>Estampa</th>
                      <th i18n>Tamanho</th>
                      <th *ngIf="SITE.mostraEstoqueDigitacao">Estoque</th>
                      <!-- <th *ngIf="pedido">Quant.</th> -->
                      <ng-container *ngIf="pedido">
                        <th class="qtd-nome-cliente" *ngFor="let cliente of pedido.clientes">
                          {{cliente.cliente.nome}}
                        </th>
                      </ng-container>
                      <th *ngIf="mostraPreco" i18n>R$ Preço</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let p of products" class="produto">
                      <td>
                        <a href="javascript:void(0);" tabindex="-1" (click)="callPhotos(p.id, p.corcod)">
                          <div *ngIf="p.imagem; else elseBlockImg">
                            <img src="{{ API_IMAGENS_PRODUTOS }}{{ p.imagem }}" class="img-fluid" />
                          </div>
                          <ng-template #elseBlockImg><img src="assets/no-product-image.jpg"
                              class="img-fluid" /></ng-template>
                        </a>
                      </td>
                      <td class="refDescr">
                        <a (click)="redirectTo(p.id)"  tabindex="-1" placeholder="NoTabIndex">{{ p.referencia
                          }}</a>
                        &nbsp; {{ p.descricao }}
                        <div *ngIf="!p.estoque && SITE.mostraDisponivelCatalogo">
                          <span class="badge badge-secondary" style="font-size: 0.7rem" i18n>Indisponível</span>
                        </div>
                      </td>
                      <td>{{ p.cordescr }}</td>
                      <td>{{ p.estampadescr }}</td>
                      <td>{{ p.tamanho }}</td>
                      <td *ngIf="SITE.mostraEstoqueDigitacao" style="font-weight: bold">
                        {{
                        this.SITE.quantidadeMaximaGrade > 0 &&
                        p.estoque >= this.SITE.quantidadeMaximaGrade
                        ? this.SITE.quantidadeMaximaGrade + "*"
                        : p.estoque
                        }}
                      </td>
                      <td *ngIf="pedido">
                        <div *ngVar="
                            p.id +
                            '@' +
                            p.corid +
                            '@' +
                            p.estampaid +
                            '@' +
                            p.tamanho +
                            '@' +
                            (pedido
                              ? pedido.clientes[0].cliente.id
                              : '') as IDFIELD
                          ">
                          <div *ngIf="
                              !pedido.tipo.validaEstoque ||
                              (pedido.tipo.validaEstoque && p.estoque > 0)
                            " class="form-group mb-0 text-center">
                            <input step="{{ p.multiplo }}" max="{{ p.quantidademaximadisponivelgrade }}" type="number"
                              min="0" (blur)="addItemCart($event)" formControlName="{{ IDFIELD }}" name="{{ IDFIELD }}"
                              [class.errorForm]="form.get(IDFIELD)?.invalid" class="form-control inputGrade" />
                          </div>
                        </div>
                      </td>
                      <td *ngIf="mostraPreco">
                        <div *ngIf="p.precoPromocional; else elseBlockPreco">
                          <span class="moneyOff" style="font-size: 0.8rem" i18n>R${{ p.preco | currency : "BRL" : ""
                            }}</span>
                          <span class="money1 ml-1" style="font-size: 0.8rem" i18n>R${{
                            p.precoPromocional | currency : "BRL" : ""
                            }}</span>
                        </div>
                        <ng-template #elseBlockPreco>
                          <div *ngIf="p.preco">
                            <span class="money" style="font-size: 0.8rem" i18n>R${{ p.preco | currency : "BRL" : ""
                              }}</span>
                          </div>
                        </ng-template>
                        <div class="moneyImposto">
                          {{
                          calculaImposto(
                          p.imposto,
                          p.precopromocional,
                          p.preco
                          )
                          }}
                        </div>
                        <div *ngIf="p.precosugerido" tooltip="Preço sugerido">
                          <span class="badge badge-primary" i18n>* R${{
                            p.precosugerido | currency : "BRL" : ""
                            }}</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </form>
          </div>

          <div *ngIf="productService.visualizacaoModo == 'grade2'" style="min-height: 300px; overflow-x: auto"
            class="row mt-2 gcc-produtos">
            <form [formGroup]="form" style="width: 100%">
              <div *ngIf="products.length > 0" class="table-responsive">
                <app-catalog-item-line [products]="products"
                  [produtoDescrHeight]="produtoDescrHeight"></app-catalog-item-line>
              </div>
            </form>
          </div>
          <div *ngIf="productService.visualizacaoModo == 'gradeClientes'" style="min-height: 550px; overflow-x: auto"
            class="row mt-2 gcc-produtos">
            <form [formGroup]="form" style="width: 100%">
              <div *ngIf="products.length > 0" class="table-responsive" style="
                  height: 80vh;
                  background: rgb(255, 255, 255);
                  overflow-y: scroll;
                " (scroll)="onTableScroll()">
                <table class="table table-hover table-condensed table-sm" [style.font-size.rem]="produtoDescrFontSize"
                  style="
                    width: 100%;
                    border-collapse: collapse;
                    text-align: left;
                  ">
                  <thead class="table-head" style="
                      background-color: white;
                      top: -5px;
                      position: sticky;
                      z-index: 10;
                    ">
                    <tr>

                      <th></th>
                      <th i18n>Produto</th>
                      <th *ngIf="SITE.mostraEstoqueDigitacao">Estoque</th>
                      <th i18n>R$ Preço</th>
                      <th class="text-align-center" *ngFor="let cli of clientes">
                        <app-show-details [cli]="cli" [identificacaoCliente]="SITE.identificacaoCliente"></app-show-details>
                      </th>
                    </tr>
                    <tr>
                      <th class="border" colspan="6"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let p of products" class="produto">
                      <td style="width: 70px;">
                        <!-- <a href="javascript:void(0);" tabindex="-1" (click)="callPhotos(p.id, p.corcod)"
                          style="position: sticky;">
                          <div class="d-flex justify-content-end" *ngIf="p.imagem; else elseBlockImg">
                            <img src="{{ API_IMAGENS_PRODUTOS }}{{ p.imagem }}" />
                          </div>
                          <ng-template #elseBlockImg>
                            <div class="d-flex justify-content-end">
                              <img src="assets/no-product-image.jpg" />
                            </div>
                          </ng-template>
                        </a> -->
                        <app-product-image #productImage [height]="'60'" [product]="p"
                          [produtoDescrHeight]="produtoDescrHeight" (onAdd)="addCart($event)"
                          (redirectTo)="redirectToEmiter.emit($event)">
                        </app-product-image>
                      </td>
                      <td class="refDescr">
                        <a (click)="redirectTo(p.id)" tabindex="-1" placeholder="NoTabIndex">{{ p.referencia
                          }}
                        </a>
                        &nbsp; {{ p.descricao }}
                        <div *ngIf="!p.estoque && SITE.mostraDisponivelCatalogo">
                          <span class="badge badge-secondary" style="font-size: 0.7rem" i18n>Indisponível</span>
                        </div>
                      </td>
                      <td *ngIf="SITE.mostraEstoqueDigitacao" style="font-weight: bold">
                        {{
                        this.SITE.quantidadeMaximaGrade > 0 &&
                        p.estoque >= this.SITE.quantidadeMaximaGrade
                        ? this.SITE.quantidadeMaximaGrade + "*"
                        : p.estoque
                        }}
                      </td>
                      <td *ngIf="mostraPreco">
                        <div *ngIf="p.precopromocional; else elseBlockPreco">
                          <span class="moneyOff" style="font-size: 0.8rem" i18n>R${{ p.preco | currency : "BRL" : ""
                            }}</span>
                          <span class="money1 ml-1" style="font-size: 0.8rem" i18n>R${{
                            p.precopromocional | currency : "BRL" : ""
                            }}</span>
                        </div>
                        <div *ngIf="p.precosugerido" tooltip="Preço sugerido">
                          <span class="badge badge-primary" i18n>* R${{
                            p.precosugerido | currency : "BRL" : ""
                            }}</span>
                        </div>
                        <ng-template #elseBlockPreco>
                          <div *ngIf="p.preco">
                            <span class="money" style="font-size: 0.8rem" i18n>R${{ p.preco | currency : "BRL" : ""
                              }}</span>
                          </div>
                        </ng-template>
                      </td>
                      <td *ngFor="let cli of clientes" style="justify-items: center;">
                        <div style="min-width: 100px; width:min-content" *ngVar="
                            p.id +
                            '@' +
                            p.corid +
                            '@' +
                            p.estampaid +
                            '@' +
                            p.tamanho +
                            '@' +
                            cli.id as IDFIELD
                          ">
                          <div *ngIf="
                              !pedido.tipo.validaEstoque ||
                              (pedido.tipo.validaEstoque && p.estoque > 0)
                            " class="form-group mb-0 text-center">
                            <div class="input-group" style="justify-content: center;">
                              <a class="noselect quantity-button-minus"
                                (click)="decrement(IDFIELD , p.multiplo, p.quantidademaximadisponivelgrade)">
                                -
                              </a>
                              <div class="quantity-input-box">
                                <input [formControlName]="IDFIELD" [name]="IDFIELD" type="number"
                                  (blur)="addItemCart($event)" (keyup.enter)="addItemCartEnter($event)"
                                  class="form-control quantity-input" min="0" style="padding: 3px 0px;" />
                              </div>
                              <a class="noselect quantity-button-plus"
                                (click)="increment(IDFIELD, p.multiplo, p.quantidademaximadisponivelgrade)">+
                              </a>
                            </div>
                          </div>
                        </div>
                      </td>
                      <!-- </ng-template> -->
                    </tr>
                  </tbody>
                  <div id="fim-produtos">&nbsp;</div>
                </table>
              </div>
            </form>
          </div>
          <div id="fim-produtos">&nbsp;</div>
        </div>
      </div>
    </div>
  </div>
  <div [style.display]="this.mobile ? 'none' : 'block'" *ngIf="pedido && mostraCarrinhoCatalogo" id="cart-catalog-fix"
    class="col-md-2" style="
      border-left: 1px solid #e5e5e5;
      padding: 0;
      max-height: 90vh;
      /* position: fixed; */
      right: 0;
      background-color: white;
    ">
    <app-catalog-cart (itemEmitted)="onItemFromCart($event)" (showCart)="(true)" (hideCart)="(false)" *ngIf="pedido"></app-catalog-cart>
    <!-- <app-cart (showCart)="true" (hideCart)="false" *ngIf="pedido">
    </app-cart> -->
  </div>
</div>

<div id="htmlLightBox"></div>

<div class="modal fade" id="shareCatalogoLink" tabindex="-1" role="dialog" aria-labelledby="searchModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 i18n>Compartilhar</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row mt-1 mb-1">
          <div class="col-12 pl-0 pr-0">
            <div class="input-group">
              <input id="shareCatalogoLinkInput" type="text" class="form-control" (click)="copyText()"
                style="color: #030303" value="{{ shareLink }}" readonly dir="ltr" />
              <div class="input-group-append">
                <span (click)="copyText()" class="input-group-text">
                  <button type="button" class="btn btn-link" style="color: #007bff" i18n>
                    COPIAR
                  </button>
                </span>
              </div>
            </div>
            <hr />
            <span style="color: grey" i18n>Disponível até {{ SITE.tempoLinkShare }} dia(s)</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade m-4 mt-5 productDetails" id="productDetails" tabindex="-1" role="dialog"
  aria-labelledby="productDetails" aria-hidden="true">
  <div class="modal-dialog" id="productDetailsModalDialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="col-1 col-sm-2 col-md-2 col-lg-7 empty-space"></div>
        <div class="col-7 col-sm-5 col-md-5 col-lg-3">
          <button (click)="copyLink()" type="button" class="copy-btn text-copy-btn">
            {{ selectedProductLink }}
          </button>
        </div>
        <div class="col-2 col-sm-4 col-md-4 col-lg-1">
          <button (click)="copyLink()" type="button" class="copy-btn">
            <!-- <i class="icofont-share-alt"></i> -->
            <svg width="15" height="30" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" fill="#888888">
              <path
                d="M 432.00,352.00c-22.58,0.00-42.96,9.369-57.506,24.415L 158.992,268.664C 159.649,264.538, 160.00,260.311, 160.00,256.00 s-0.351-8.538-1.008-12.663l 215.502-107.751C 389.04,150.631, 409.42,160.00, 432.00,160.00c 44.183,0.00, 80.00-35.817, 80.00-80.00S 476.183,0.00, 432.00,0.00 s-80.00,35.817-80.00,80.00c0.00,4.311, 0.352,8.538, 1.008,12.663L 137.506,200.415C 122.96,185.37, 102.58,176.00, 80.00,176.00c-44.183,0.00-80.00,35.818-80.00,80.00 c0.00,44.184, 35.817,80.00, 80.00,80.00c 22.58,0.00, 42.96-9.369, 57.506-24.414l 215.502,107.751C 352.352,423.462, 352.00,427.689, 352.00,432.00 c0.00,44.184, 35.817,80.00, 80.00,80.00s 80.00-35.816, 80.00-80.00C 512.00,387.818, 476.183,352.00, 432.00,352.00z">
              </path>
            </svg>
          </button>
        </div>
        <div class="col-1">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="modal-body">
        <div class="row mt-1 mb-1">
          <div class="col-12 pl-0 pr-0">
            <app-page-produto *ngIf="showProduct" [productId]="selectedProduct"
              (updateQuantity)="updateQuantity($event)" (redirectTo)="redirectTo($event)"></app-page-produto>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<a *ngIf="mobile" href="javascript:void(0);" class="mobile-filter-button"
  [style.backgroundColor]="SITE.backgroundColorSliderSuperior" (click)="toggleFilter()">
  <img src="assets/filter.png" width="20" />
</a>